import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import {Content} from '../Styles'

const ErrorBox = ({error, contentProps, ...other}) => {

    return (
        <Content {...contentProps}>
            <Typography
                variant="subtitle1"
                color='error'
                gutterBottom
                {...other}
            >
                {error}
            </Typography>
        </Content>
    )
}

ErrorBox.propTypes = {
    error: PropTypes.any.isRequired,
    contentProps: PropTypes.object,
}

export default ErrorBox
